import React from "react";
import { Modal, Text, Stack, Box } from "@mantine/core";
import { IconCheck } from "@tabler/icons-react";
import styles from "./OnboardingDashboard.module.css";

interface MigrationSuccessModalProps {
  opened: boolean;
  onClose: () => void;
}

export default function MigrationSuccessModal({
  opened,
  onClose,
}: MigrationSuccessModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      size="sm"
      radius="lg"
      px="lg"
      withCloseButton
      transitionProps={{ transition: "fade", duration: 200 }}
      classNames={{
        content: styles.migrationModalContent,
        overlay: styles.migrationModalOverlay,
        title: styles.migrationModalHiddenTitle,
      }}
      styles={{
        body: { overflow: "visible" },
      }}
    >
      <Stack align="center" className={styles.migrationModalBody}>
        <Box className={styles.migrationModalIconWrapper}>
          <IconCheck size={40} stroke={2.5} color="#fff" />
        </Box>
        <Text
          size="xl"
          fw={700}
          ta="center"
          className={styles.migrationModalTitle}
        >
          Request received!
        </Text>
        <Text ta="center" c="dimmed" className={styles.migrationModalMessage}>
          Our team will reach out shortly to help with the migration process.
        </Text>
      </Stack>
    </Modal>
  );
}
